import { Box, Stack } from '@mui/material';
import React from 'react';
import { Image, Shimmer } from 'react-shimmer';

export default function ShimmerCard() {
  return (
    <Stack
      ml={{ xs: '0px', sm: '0px', md: '88px', lg: '88px' }}
      mr={{ xs: '0px', sm: '0px', md: '88px', lg: '88px' }}
      pb="40px"
      justifyContent="center"
    >
      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
        justifyContent={{
          xs: 'center',
          sm: 'center',
          md: 'flex-start',
          lg: 'flex-start',
        }}
        flexWrap="wrap"
        alignItems="center"
        gap={2}
        mt={{ xs: '10px', sm: '10px', md: '20px', lg: '60px' }}
      >
        <Box
          height="330px"
          width="305px"
          sx={{
            cursor: 'pointer',
            verticalAlign: 'middle',
            display: 'block',
            borderRadius: '5px',
            boxShadow:
              '0px 3px 8px -1px rgba(50, 50, 71, 0.05), 0px 0px 1px 0px rgba(12, 26, 75, 0.24)',
          }}
        >
          <div className="shimmer-card"></div>
          <Stack>
            <div className="line1"></div>
            <br></br>
            <div className="line2"></div>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
}
